import React, { Fragment } from "react";
import { Typography } from "@material-ui/core";
import { ActivityRow } from "./ActivityRow";
import { Activity } from "../../../api/services";
import { isPending, useActivityGroups } from "../hooks/useActivityGroups";
import { InlineType } from "../../../components/InlineType";
import {
  CustomTableCell,
  CustomTableRow,
} from "../../../components/CustomTableComponents";

export const ActivityTableBody: React.FC<{
  activities: Activity[];
}> = ({ activities }) => {
  const { groups, headers } = useActivityGroups(activities);
  return (
    <>
      {headers.map((header) => (
        <Fragment key={`activity-fragment-${header}`}>
          <CustomTableRow isGrey={isPending(header)}>
            <CustomTableCell colSpan={5} data-testid="ActivityView--RowHead">
              <Typography variant="body2">
                <InlineType fontWeight="bold">{header}</InlineType>
              </Typography>
            </CustomTableCell>
          </CustomTableRow>
          {groups[header].map((activity) => (
            <ActivityRow
              activity={activity}
              key={activity.id}
              isGrey={isPending(header)}
            />
          ))}
        </Fragment>
      ))}
    </>
  );
};
